import styled from "styled-components";

export const LoginContainer = styled.div`
    width: 100%;
    height: 100vh;
    min-height: 100dvh;
    overflow: hidden;
`;
